import { Pencil, Lock, Trash2 } from 'lucide-react';
import { notasApi } from '../api/notas';

function fmtDate(d) {
  if (!d) return '';
  const date = new Date(d);
  return date.toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
}

export function CardNota({ nota, empleados, servicios, onChanged }) {
  const bloqueada = nota.procesadaEnRelacion;
  const categoria = nota.servicioCategoria || nota.categoria;

  const handleEliminar = async () => {
    if (!confirm('¿Eliminar esta nota?')) return;
    try {
      await notasApi.eliminar(nota.clienteId, nota.id);
      onChanged?.();
    } catch (e) {
      alert(e?.response?.data?.error || 'No se pudo eliminar la nota');
    }
  };

  const handleVerRelacion = () => {
    // TODO: navegar a detalle de relación si hay id
    if (nota.relacionId) {
      window.location.href = `/clientes/${nota.clienteId}/relaciones/${nota.relacionId}`;
    }
  };

  return (
    <div
      className={`bg-panel border rounded-xl p-4 space-y-2 ${
        bloqueada
          ? 'border-amber-500/30 opacity-90'
          : 'border-border hover:border-cyan-500/40'
      } transition`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap text-xs text-muted">
            <span className="font-mono">{fmtDate(nota.fecha)}</span>
            {nota.empleadoNombre && <span>· {nota.empleadoNombre}</span>}
            {categoria && (
              <span className="px-1.5 py-0.5 bg-cyan-500/15 text-cyan-400 rounded text-[10px] uppercase tracking-wide">
                {categoria}
              </span>
            )}
          </div>
          <p className="text-sm text-white mt-1 break-words">{nota.descripcion}</p>
        </div>
        {bloqueada ? (
          <div className="flex items-center gap-1 text-amber-400 text-xs" title="Procesada en relación">
            <Lock size={12} /> #{nota.relacionId}
          </div>
        ) : null}
      </div>

      <div className="flex items-center justify-between text-xs text-muted pt-1 border-t border-border/40">
        <div>
          <span className="text-emerald-400 font-mono">${nota.importe.toFixed(2)}</span>
          {nota.descuentoPct > 0 && (
            <span className="ml-2 text-amber-400">
              -{nota.descuentoPct}% → <strong className="font-mono">${nota.importeEfectivo.toFixed(2)}</strong>
            </span>
          )}
          <span className="ml-2">· {nota.servicioNombre || nota.nombreServicio || 'Sin servicio'}</span>
        </div>

        {bloqueada ? (
          <button
            onClick={handleVerRelacion}
            className="text-cyan-400 hover:text-cyan-300 text-xs"
            title="Ver relación"
          >
            Ver relación
          </button>
        ) : (
          <div className="flex items-center gap-1">
            <button
              onClick={handleEliminar}
              className="p-1.5 rounded text-slate-400 hover:text-rose-400 hover:bg-rose-500/10"
              title="Eliminar"
            >
              <Trash2 size={13} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
